var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBronzeRank5(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bronze_rank_5_svg__clip0_1947_6963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bronze_rank_5_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 199
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.865.111H0v198.777h200.865V.111z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bronze_rank_5_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.334 38.52c-5.344-5.624-14.62-4.162-18.037 2.806-8.93 18.192-6.153 40.792 8.615 56.336 18.43 19.395 48.732 20.646 68.68 3.217l-59.258-62.36z",
    fill: "#DDA37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 75.972C6.903 73.724-.439 79.582.024 87.331c1.201 20.24 14.761 38.514 35.265 44.725 25.585 7.749 52.553-6.152 61.308-31.177L14.322 75.972z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 122.27c-7.507 1.932-10.76 10.755-6.358 17.141 11.497 16.689 32.546 25.283 53.291 19.953 25.89-6.651 41.771-32.538 36.315-58.485l-42.55 10.931-40.704 10.455.006.005z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 38.52c5.344-5.624 14.621-4.162 18.037 2.806 8.931 18.192 6.153 40.792-8.614 56.336-18.43 19.395-48.732 20.646-68.68 3.217l59.257-62.36z",
    fill: "#DDA37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.543 75.972c7.419-2.248 14.762 3.61 14.305 11.365-1.202 20.24-14.762 38.514-35.266 44.725-25.585 7.749-52.553-6.152-61.308-31.177l82.269-24.913z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 122.27c7.507 1.932 10.759 10.755 6.358 17.141-11.497 16.689-32.547 25.283-53.291 19.953-25.89-6.651-41.77-32.538-36.315-58.485l42.55 10.931 40.704 10.455-.006.005z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792.111h108.224c6.47 0 11.72 5.26 11.72 11.74v121.086c0 36.395-29.499 65.945-65.832 65.945-36.332 0-65.832-29.55-65.832-65.945V11.852c0-6.481 5.25-11.74 11.72-11.74z",
    fill: "#CE7C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.195 67.8h75.413c4.506 0 8.169 3.664 8.169 8.184v49.492c0 25.365-20.557 45.952-45.873 45.952-25.321 0-45.872-20.593-45.872-45.952V75.984c0-4.514 3.657-8.183 8.169-8.183h-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 70.149c3.211 0 5.825 2.618 5.825 5.835v49.492c0 24.044-19.526 43.603-43.529 43.603-24.002 0-43.528-19.559-43.528-43.603V75.984c0-3.217 2.613-5.835 5.825-5.835h75.413m0-2.348h-75.42c-4.511 0-8.168 3.663-8.168 8.183v49.492c0 25.376 20.54 45.952 45.872 45.952 25.334 0 45.873-20.576 45.873-45.952V75.984c0-4.52-3.657-8.183-8.169-8.183h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.016.111h-44.982L35.072 75.203v51.734l125.3-125.522A11.645 11.645 0 00155.016.11zM95.712 112.643l71.024-71.147V12.181L81.079 97.986l14.633 14.657z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.966 22.136L82 28.406a1.677 1.677 0 001.6 1.162h6.58c1.63 0 2.303 2.084.985 3.04l-5.321 3.875a1.688 1.688 0 00-.61 1.879l2.034 6.27c.504 1.549-1.266 2.84-2.584 1.878l-5.321-3.875a1.678 1.678 0 00-1.975 0l-5.321 3.875c-1.318.956-3.088-.33-2.584-1.879l2.033-6.27a1.688 1.688 0 00-.61-1.878l-5.32-3.874c-1.319-.957-.639-3.04.984-3.04h6.581c.727 0 1.371-.47 1.6-1.163l2.033-6.27c.504-1.55 2.69-1.55 3.194 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.966 22.136L82 28.406a1.677 1.677 0 001.6 1.162h6.58c1.63 0 2.303 2.084.985 3.04l-5.321 3.875a1.688 1.688 0 00-.61 1.879l2.034 6.27c.504 1.549-1.266 2.84-2.584 1.878l-5.321-3.875a1.678 1.678 0 00-1.975 0l-5.321 3.875c-1.318.956-3.088-.33-2.584-1.879l2.033-6.27a1.688 1.688 0 00-.61-1.878l-5.32-3.874c-1.319-.957-.639-3.04.984-3.04h6.581c.727 0 1.371-.47 1.6-1.163l2.033-6.27c.504-1.55 2.69-1.55 3.194 0h-.012z",
    fill: "#FEE066"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.686 22.136l2.034 6.27a1.676 1.676 0 001.599 1.162h6.581c1.629 0 2.303 2.084.985 3.04l-5.321 3.875a1.689 1.689 0 00-.61 1.879l2.034 6.27c.504 1.549-1.266 2.84-2.584 1.878l-5.321-3.875a1.678 1.678 0 00-1.975 0l-5.321 3.875c-1.319.956-3.088-.33-2.584-1.879l2.033-6.27a1.687 1.687 0 00-.609-1.878l-5.321-3.874c-1.319-.957-.639-3.04.984-3.04h6.581c.727 0 1.371-.47 1.6-1.163l2.033-6.27c.504-1.55 2.69-1.55 3.194 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.686 22.136l2.034 6.27a1.676 1.676 0 001.599 1.162h6.581c1.629 0 2.303 2.084.985 3.04l-5.321 3.875a1.689 1.689 0 00-.61 1.879l2.034 6.27c.504 1.549-1.266 2.84-2.584 1.878l-5.321-3.875a1.678 1.678 0 00-1.975 0l-5.321 3.875c-1.319.956-3.088-.33-2.584-1.879l2.033-6.27a1.687 1.687 0 00-.609-1.878l-5.321-3.874c-1.319-.957-.639-3.04.984-3.04h6.581c.727 0 1.371-.47 1.6-1.163l2.033-6.27c.504-1.55 2.69-1.55 3.194 0h-.012z",
    fill: "#FEE066"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bronze_rank_5_svg__clip0_1947_6963"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h201v199H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeRank5);
export default ForwardRef;